import React from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';

/**
 * Reports are organized into LOGICAL GROUPS so a report-runner finds things by
 * subject (Queues / Agents / State & AUX / Calls / QA / Compliance) instead of
 * scanning a flat wall of tabs. (2026-08-10 reorg + agent-state reports.)
 */
const GROUPS = [
  {
    label: 'Queues',
    tabs: [
      { to: 'queues', label: 'Queue performance' },
      { to: 'acd',    label: 'ACD historical' },
      { to: 'trunks', label: 'Trunks' },
    ],
  },
  {
    label: 'Agents',
    tabs: [
      { to: 'agents',         label: 'Agent productivity' },
      { to: 'agents-by-interaction', label: 'Agent handle (Interaction)' },
      { to: 'agent-state',    label: 'Agent state summary' },
      { to: 'agent-timeline', label: 'Agent timeline' },
    ],
  },
  {
    label: 'State & AUX',
    tabs: [
      { to: 'aux-reasons', label: 'AUX / Not-Ready' },
    ],
  },
  {
    label: 'Calls',
    tabs: [
      { to: 'cdr',       label: 'CDR drill-down' },
      { to: 'transfers', label: 'Transfers' },
    ],
  },
  {
    label: 'QA',
    tabs: [
      { to: 'qa', label: 'QA scorecards' },
    ],
  },
  {
    label: 'Compliance & Recording',
    tabs: [
      { to: 'compliance',    label: 'Outbound compliance' },
      { to: 'coverage',      label: 'Recording coverage' },
      { to: 'coverage-gaps', label: 'Coverage gaps' },
      { to: 'storage',       label: 'Storage & archive' },
    ],
  },
];

export function ReportsIndexRedirect() {
  return <Navigate to="queues" replace />;
}

export default function ReportsLayout() {
  return (
    <div className="flex flex-col h-full">
      <div className="px-6 pt-4 border-b border-surface-border dark:border-surface-dark-border">
        <h1 className="text-lg font-semibold mb-3">Reports</h1>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 -mb-px pb-1">
          {GROUPS.map((g) => (
            <div key={g.label} className="flex flex-col">
              <span className="text-[10px] uppercase tracking-wider text-surface-muted dark:text-surface-dark-muted mb-1 px-1">
                {g.label}
              </span>
              <div className="flex gap-1">
                {g.tabs.map((t) => (
                  <NavLink
                    key={t.to}
                    to={t.to}
                    className={({ isActive }) =>
                      'px-3 py-1.5 text-sm rounded-thin border whitespace-nowrap ' +
                      (isActive
                        ? 'border-continuum-500 bg-continuum-50 dark:bg-continuum-900/30 text-continuum-700 dark:text-continuum-200 font-medium'
                        : 'border-surface-border dark:border-surface-dark-border text-surface-text dark:text-surface-dark-text hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle')
                    }
                  >
                    {t.label}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>
      <div className="flex-1 overflow-auto p-6">
        <Outlet />
      </div>
    </div>
  );
}
